import React from 'react'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

export default function AzubiListHOC(WrappedComponent) {
  // eslint-disable-next-line no-shadow
  class AzubiListHOC extends React.Component {
    componentDidMount() {
      const {hasAzubis} = this.props.permissions.meineAzubis
      if (hasAzubis && this.azubisNotLoaded() && !this.props.isLoading) {
        actions.azubis.getAzubis()
      }
    }

    azubisNotLoaded() {
      return !this.props.azubis
    }

    render() {
      const {azubis, isLoading, ...reducedProps} = this.props
      if (azubis) {
        return <WrappedComponent {...reducedProps} azubis={azubis} />
      }
      if (!this.props.permissions.meineAzubis.hasAzubis) {
        return <WrappedComponent {...reducedProps} azubis={[]} />
      }
      return <WrappedComponent {...reducedProps} azubis={[]} isLoadingAzubis />
    }
  }

  AzubiListHOC.propTypes = {
    azubis: PropTypes.array,
    permissions: PropTypes.object,
    isLoading: PropTypes.bool,
  }

  const mapStateToProps = state => ({
    azubis: state.azubis.allAzubis,
    permissions: state.authentication.permissions,
    isLoading: state.azubis.loading.getAzubis,
  })
  return connect(mapStateToProps)(AzubiListHOC)
}
